// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const repliesHistoryConfig = {
    title: 'chart.twitter.replies_history',
    tooltip: 'chart.twitter.replies_history_tooltip',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.replies_history_name',
        avg: 'chart.twitter.replies_history_avg'
    },
    id: 'replies_history',
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
